define(
    'providers/dataprovider.organisations',[
        "services/config"
    ],
    function (config) {

        function getOrganisations() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-organisations-organisation-organisations",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getOrganisation(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-organisation",
                    data: { id: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function addOrganisation(rec) {
            var data = {
                name: rec.name,
                description: rec.description,
                website: rec.website
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-organisations-organisation",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function updateOrganisation(rec) {
            var data = {                
                id: rec.id,
                name: rec.name,
                description: rec.description,
                website: rec.website
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-organisations-organisation",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function addPeopleToOrganisation(rec) {
            var data = {
                id: rec.id,
                persons: rec.persons
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-organisations-addpeopletoorganisation",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function deleteOrganisation(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-organisations-organisation",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function removePeopleFromOrganisation(rec) {
            var data = {
                id: rec.organisationId,
                personId: rec.personId
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-organisations-removepeoplefromorganisation",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getOrganisations: getOrganisations,
            getOrganisation: getOrganisation,
            addOrganisation: addOrganisation,
            updateOrganisation: updateOrganisation,
            addPeopleToOrganisation: addPeopleToOrganisation,
            deleteOrganisation: deleteOrganisation,
            removePeopleFromOrganisation: removePeopleFromOrganisation
        };

        function init() {
            //#region Organisation Maintenance Operations

            amplify.request.define("get-organisations-organisation-organisations", "ajax", {
                url: getUrl("admin/organisations"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-organisation", "ajax", {
                url: getUrl("admin/organisations/{id}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("pos-organisations-organisation", "ajax", {
                url: getUrl("admin/organisations"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("put-organisations-organisation", "ajax", {
                url: getUrl("admin/organisations/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("put-organisations-addpeopletoorganisation", "ajax", {
                url: getUrl("admin/organisations/{id}/addpeople"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {                    
                    return JSON.stringify(data.persons);
                },
            });

            amplify.request.define("del-organisations-organisation", "ajax", {
                url: getUrl("admin/organisations/{id}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("del-organisations-removepeoplefromorganisation", "ajax", {
                url: getUrl("admin/organisations/{id}/member/{personId}"),
                dataType: "json",
                type: "DELETE",
                dataMap: function (data) {
                    return JSON.stringify(data.persons);
                },
            });
            //#endregion
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }
    }
);
